<template>
  <Field
    v-slot="{ field, errors, meta }"
    :name="id+''"
    :rules="rules"
  >
    <div
      v-bind="$attrs"
      :class="{
        'inputInvalid': errors.length > 0 && showError,
        'inputSuccess': meta.dirty && meta.valid,
      }"
      class="inputField"
    >
      <label
        class="textBold"
        :for="id"
      >
        {{ label }}
        <span
          v-if="isRequired"
          class="bold"
          style="color:var(--systemError)"
        >*</span>
      </label>

      <Dropdown
        v-bind="field"
        :id="id"
        v-model="innerValue"
        :option-label="optionLabel"
        :option-value="optionValue"
        :options="options"
      />

      <span
        v-if="errors.length"
        class="errorMessage"
      >
        Érvénytelen vagy hiányos adat!
      </span>
    </div>
  </Field>
</template>

<script setup>
import { Field } from 'vee-validate';
</script>

<script>
export default {
  props: {
    id: {
      type: Number,
    },
    vid: {
      type: String,
    },
    rules: {
      type: [Object, String],
      default: "",
    },
    // must be included in props
    value: {
      type: null,
    },
    label: {
      type: String,
    },
    options: {
      default: [],
    },
    optionValue: {
      type: String,
      required: false,
      default: 'value',
    },
    optionLabel: {
      type: String,
      required: false,
      default: 'text',
    },
    isRequired: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  emits: ['input'],
  data: () => ({
    innerValue: "",
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit("input", newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
};
</script>
